var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3656 8.23441C13.5155 8.38443 13.5998 8.58787 13.5998 8.80001C13.5998 9.01214 13.5155 9.21558 13.3656 9.36561L8.56557 14.1656C8.41554 14.3156 8.2121 14.3998 7.99997 14.3998C7.78784 14.3998 7.58439 14.3156 7.43437 14.1656L2.63437 9.36561C2.55796 9.29181 2.49701 9.20353 2.45509 9.10593C2.41316 9.00833 2.39109 8.90335 2.39017 8.79713C2.38924 8.6909 2.40949 8.58556 2.44971 8.48724C2.48993 8.38893 2.54934 8.2996 2.62445 8.22449C2.69957 8.14938 2.78889 8.08997 2.8872 8.04975C2.98552 8.00952 3.09086 7.98928 3.19709 7.9902C3.30331 7.99113 3.40829 8.0132 3.50589 8.05512C3.60349 8.09705 3.69177 8.158 3.76557 8.23441L7.19997 11.6688V2.40001C7.19997 2.18783 7.28425 1.98435 7.43428 1.83432C7.58431 1.68429 7.78779 1.60001 7.99997 1.60001C8.21214 1.60001 8.41562 1.68429 8.56565 1.83432C8.71568 1.98435 8.79997 2.18783 8.79997 2.40001V11.6688L12.2344 8.23441C12.3844 8.08443 12.5878 8.00018 12.8 8.00018C13.0121 8.00018 13.2155 8.08443 13.3656 8.23441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.aea8968a5f3f70f7e0dec46ac384f2a4.svg";
export { ForwardRef as ReactComponent };